import * as React from "react"

interface Props extends React.SVGProps<SVGSVGElement> {
  title?: String
}

function HelpIcon(props: Props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" {...props}>
      <title>{props.title ?? "Help"}</title>
      <defs>
        <filter id="prefix__a">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
          />
        </filter>
      </defs>
      <g
        transform="translate(-909 -1050)"
        filter="url(#prefix__a)"
        fill="none"
        fillRule="evenodd"
      >
        <g transform="translate(909 1050)">
          <path
            d="M10.934 12.308v-.378c0-.299.058-.57.175-.812a1.87 1.87 0 01.434-.595c.173-.154.36-.324.56-.511.2-.187.387-.366.56-.539a2.05 2.05 0 00.434-.693c.117-.29.175-.616.175-.98 0-.821-.264-1.493-.791-2.016C11.954 5.261 11.214 5 10.262 5c-.98 0-1.769.296-2.366.889C7.299 6.482 7 7.296 7 8.332h1.638c0-.56.142-.996.427-1.309.285-.313.684-.469 1.197-.469.43 0 .765.117 1.008.35.243.233.364.532.364.896 0 .243-.058.469-.175.679-.117.21-.261.383-.434.518s-.36.294-.56.476c-.2.182-.387.369-.56.56-.173.191-.317.45-.434.777a3.274 3.274 0 00-.175 1.106v.392h1.638zm-.812 2.828c.317 0 .583-.103.798-.308.215-.215.322-.476.322-.784a1.05 1.05 0 00-.322-.77 1.084 1.084 0 00-.798-.322c-.317 0-.583.105-.798.315-.215.21-.322.469-.322.777 0 .308.107.567.322.777.215.21.48.315.798.315z"
            fill="#000"
            fillRule="nonzero"
          />
          <circle stroke="#000" strokeWidth={1.4} cx={10} cy={10} r={9.3} />
        </g>
      </g>
    </svg>
  )
}

export default HelpIcon
